import {Analytics, GTag, GTagEventObserver, GTagPageviewObserver} from '@plaudit/analytics';
import FacebookPixel from "@plaudit/analytics/dist/tracker/FacebookPixel";

Analytics.setup();

const gtag = GTag.getInstance();
const facebookPixel = FacebookPixel.getInstance();

if (gtag !== null) {
	gtag.addObserver(

		new GTagPageviewObserver(
			{
				// pagePath: (value: string) => {
				// 	return value === "/anniversary-success"
				// 		|| value === "/product-success"
				// 		|| value === "/find-a-contractor-success"
				// 		|| value === "/general-question-success"
				// }
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 500 });
			}
		)
	);

	gtag.addObserver(
		new GTagEventObserver(
			{
				// Email or Telephone Click
				eventCategory: (value: string) => value === "Email Link" || value === "Telephone Link",
				eventAction: (value: string) => value === "Click"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 250 });
			},
		)
	);
}
